import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

interface EstadoPresupuesto {
  clave: string;
  nombreEstado: string;
  modificado: number;
  totalEjercido: number;
  subEjercicio: number;
}

@Component({
  selector: 'modal-detalle-presupuesto-estado',
  templateUrl: './modal-detalle-presupuesto-estado.component.html',
  styleUrls: ['./modal-detalle-presupuesto-estado.component.scss']
})
export class ModalDetallePresupuestoEstadoComponent implements OnInit {

  @Input('estadoPresupuestoSeleccionado')
  public estadoPresupuestoSeleccionado: EstadoPresupuesto;

  @ViewChild('modalPresupuestosProgramas')
  public modalPresupuestosProgramas: any;
  public modalActivo: NgbModalRef;
  public ruralesSeleccionado: boolean;
  public federalesSeleccionado: boolean;


  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }

  public abrirModal(ruralesSeleccionado: boolean, federalesSeleccionado: boolean) {

    this.ruralesSeleccionado = ruralesSeleccionado;
    this.federalesSeleccionado = federalesSeleccionado;
    this.modalActivo = this.modalService.open(this.modalPresupuestosProgramas, { centered: true, size: 'lg', windowClass: 'modal-ficha-tecnica' });
  }

  public cerrarModal(): void {
    this.modalActivo.close();
  }

}
